import { KampaayDataProvider } from 'services/api/dataProvider'
import { Upselling } from 'services/api/entities/catalog/upselling/types/internal/upselling-models'
import { parseCsvFields } from 'services/utils/multilangParseWrite'
import { EntityDescriptor } from '.'
import { formatPriceRange } from './common'

export const locationupselling: EntityDescriptor<Upselling> = {
  format:
    (_dataProvider?: KampaayDataProvider) =>
    ({ name, description, ...record }) => ({
      id: record.id,
      ...parseCsvFields({ name, description: description ?? '' }),
      facets: record.facets,
      priceRanges: record.pricing.map(formatPriceRange),
    }),
}
